// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__UFEM6","load6":"loader_load6__Kt2zW","round":"loader_round__chPOC"};